import React from 'react';
import PAGE_TYPES from 'tradera-constants/page-types';
import ApplicationErrorBoundary from 'tradera-components/application-error-boundary';
import { NoItemsError } from 'tradera-components/errors';
import SearchResultsWrapper from '../components/discover/containers/search-results-wrapper';

function CategoryPage(props) {
    const { location, loadStatus } = props;
    return (
        <ApplicationErrorBoundary fallback={<NoItemsError />}>
            <SearchResultsWrapper
                pageType={PAGE_TYPES.CATEGORY_RESULT_PAGE}
                searchPath={location.pathname}
                loadStatus={loadStatus}
            />
        </ApplicationErrorBoundary>
    );
}

export default CategoryPage;
